import {
  type DisconnectionDetails,
  type PartialOptions,
  type VoiceConversation,
} from '@elevenlabs/client';

import { ELEVENLABS_BROWSER_SDK_VERSION } from './voiceClientDiagnostics.js';

export { ELEVENLABS_BROWSER_SDK_VERSION };
export type { DisconnectionDetails };

type PrivateWebSocketOptions = Extract<PartialOptions, { signedUrl: string }> & {
  textOnly?: false;
};

type TestConversationNamespace = {
  startSession(options: PrivateWebSocketOptions): Promise<VoiceConversation>;
};

type ElevenLabsBrowserModule = {
  Conversation: TestConversationNamespace;
};

let conversationNamespace: TestConversationNamespace | undefined;

export function resolveElevenLabsBrowserSdkUrl(
  middlewareUrl: string,
  pageUrl: string = globalThis.location.href
): string {
  const apiBaseUrl = new URL(`${middlewareUrl.replace(/\/+$/u, '')}/`, pageUrl);
  return new URL('../bundle/elevenlabs-client.js', apiBaseUrl).href;
}

declare global {
  // This hook is reachable only with the backend's explicit mock-sdk token and
  // lets browser acceptance exercise lifecycle races without a live agent.

  var __OTOKOC_TEST_ELEVENLABS_CONVERSATION__: TestConversationNamespace | undefined;
}

export async function startElevenLabsVoiceSession(
  options: PrivateWebSocketOptions,
  sdkUrl: string
): Promise<VoiceConversation> {
  const sessionOptions = {
    ...options,
    connectionType: 'websocket' as const,
    textOnly: false as const,
  };

  if (
    options.signedUrl.startsWith('mock-sdk:') &&
    globalThis.__OTOKOC_TEST_ELEVENLABS_CONVERSATION__
  ) {
    return globalThis.__OTOKOC_TEST_ELEVENLABS_CONVERSATION__.startSession(sessionOptions);
  }

  if (!conversationNamespace) {
    const module = (await import(/* @vite-ignore */ sdkUrl)) as ElevenLabsBrowserModule;
    conversationNamespace = module.Conversation;
  }
  if (!conversationNamespace?.startSession) {
    throw new Error('ElevenLabs browser SDK did not expose Conversation.startSession');
  }
  return conversationNamespace.startSession(sessionOptions);
}
